import { gql } from "@apollo/client";

export const GET_EVOLUCION_ASISTENCIAL = gql`
query GetEvolucionAsistencial($idEvaluacion: Int!, $idPaciente: Int!) {
    evolucionAsistencial(
        idEvaluacion: $idEvaluacion,
        idPaciente: $idPaciente
    ) {
        idEvaluacion
        profesional
        idModulo
        idEstadoMedico
        fechaCierreRIMedico
        usuarioCoordinador
        fechaNotifAsistencial
        fechaEstadoMedico
        observacionMedica
        programa
        idDatosGeneralesRI
        tipoNotificacion
        idEstadoCoordinacion
        idEstadoConfirmarEquipo
    }
}`;


export const adaptEvolucionAsistencial = (data) => {
  const tipoNotificacion = data?.evolucionAsistencial?.tipoNotificacion === 1 ?
  "RESUMEN_INGRESO" : data?.evolucionAsistencial?.tipoNotificacion === 2 ? "INGRESO_INDICACION" : "CAMBIO_INDICACION";
  return {
    idEvaluacion: data?.evolucionAsistencial?.idEvaluacion,
    profesional: data?.evolucionAsistencial?.profesional,
    idModulo: data?.evolucionAsistencial?.idModulo,
    estadoMedico: data?.evolucionAsistencial?.idEstadoMedico,
    fechaCierreRIMedico: data?.evolucionAsistencial?.fechaCierreRIMedico,
    usuarioCoordinador: data?.evolucionAsistencial?.usuarioCoordinador,
    fechaNotifAsistencial: data?.evolucionAsistencial?.fechaNotifAsistencial,
    fechaEstadoMedico: data?.evolucionAsistencial?.fechaEstadoMedico,
    observacionMedica: data?.evolucionAsistencial?.observacionMedica,
    programa: data?.evolucionAsistencial?.programa,
    idDatosGeneralesRI: data?.evolucionAsistencial?.idDatosGeneralesRI,
    tipoNotificacion: tipoNotificacion,
    idEstadoCoordinacion: data?.evolucionAsistencial?.idEstadoCoordinacion,
    idEstadoConfirmarEquipo: data?.evolucionAsistencial?.idEstadoConfirmarEquipo
  };
};